import { FormControl, FormLabel } from "@chakra-ui/react";

import { AddressTile } from "@/components/AddressTile";

type ShieldedAddressFieldProps = {
  address: string;
  balance: number;
};

export const ShieldedAddressField = ({ address, balance }: ShieldedAddressFieldProps) => (
  <FormControl>
    <FormLabel>From</FormLabel>
    <AddressTile
      address={{ type: "sapling", pkh: address }}
      balance={balance.toString()}
      hideBalance={false}
    />
  </FormControl>
);
